import tw from 'tailwind-styled-components'

export const TestListCampaignContainer = tw.div`
    py-10
    relative
`
